class SizeGuideTable extends HTMLElement {
  constructor() {
    super();
    this.isMobile = window.innerWidth <= 768;
    this.highlightedRow = null;
    this.highlightedColumn = null;
    this.isClickMode = false;
    
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupResponsiveHandling();
  }

  setupEventListeners() {
    const table = this.querySelector('table');
    if (!table) return;

    const cells = table.querySelectorAll('td, th');
    
    cells.forEach(cell => {
      // Desktop hover events
      cell.addEventListener('mouseenter', () => {
        if (!this.isMobile) {
          this.highlightRowAndColumn(cell);
        }
      });

      cell.addEventListener('mouseleave', () => {
        if (!this.isMobile && !this.isClickMode) {
          this.clearHighlights();
        }
      });

      // Mobile click events
      cell.addEventListener('click', (e) => {
        if (this.isMobile) {
          e.preventDefault();
          this.toggleClickHighlight(cell);
        }
      });

      // Touch events for better mobile support
      cell.addEventListener('touchstart', (e) => {
        if (this.isMobile) {
          e.preventDefault();
          this.toggleClickHighlight(cell);
        }
      });
    });

    // Clear highlights when clicking outside the table
    document.addEventListener('click', (e) => {
      if (this.isMobile && !this.contains(e.target)) {
        this.clearHighlights();
        this.isClickMode = false;
      }
    });
  }

  setupResponsiveHandling() {
    const handleResize = () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 768;
      
      // Clear highlights when switching between mobile and desktop
      if (wasMobile !== this.isMobile) {
        this.clearHighlights();
        this.isClickMode = false;
      }
    };

    window.addEventListener('resize', handleResize);
  }

  highlightRowAndColumn(cell) {
    this.clearHighlights();
    
    const row = cell.closest('tr');
    const columnIndex = Array.from(row.children).indexOf(cell);
    
    if (row && columnIndex !== -1) {
      // Highlight the entire row
      row.classList.add('highlighted-row');
      this.highlightedRow = row;
      
      // Highlight all cells in the same column
      const table = this.querySelector('table');
      const allRows = table.querySelectorAll('tr');
      
      allRows.forEach(tableRow => {
        const columnCell = tableRow.children[columnIndex];
        if (columnCell) {
          columnCell.classList.add('highlighted-column');
        }
      });
      
      this.highlightedColumn = columnIndex;
    }
  }

  toggleClickHighlight(cell) {
    const row = cell.closest('tr');
    const columnIndex = Array.from(row.children).indexOf(cell);
    
    // If clicking the same cell, toggle off
    if (this.isClickMode && 
        this.highlightedRow === row && 
        this.highlightedColumn === columnIndex) {
      this.clearHighlights();
      this.isClickMode = false;
      return;
    }
    
    // Otherwise, highlight the new cell's row and column
    this.highlightRowAndColumn(cell);
    this.isClickMode = true;
  }

  clearHighlights() {
    // Remove row highlights
    if (this.highlightedRow) {
      this.highlightedRow.classList.remove('highlighted-row');
      this.highlightedRow = null;
    }
    
    // Remove column highlights
    if (this.highlightedColumn !== null) {
      const table = this.querySelector('table');
      const allCells = table.querySelectorAll('td, th');
      allCells.forEach(cell => {
        cell.classList.remove('highlighted-column');
      });
      this.highlightedColumn = null;
    }
  }

  // Clean up event listeners when component is removed
  disconnectedCallback() {
    this.clearHighlights();
  }
}

// Register the custom element
customElements.define('size-guide-table', SizeGuideTable);